import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { MatterIntakeTemplate } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterIntakeTemplateRowContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  onDelete: () => void;
  onEdit: () => void;
  template: MatterIntakeTemplate;
  trigger: ReactNode;
};

export function MatterIntakeTemplateRowContextMenu({
  canDelete,
  canEdit,
  onDelete,
  onEdit,
  template,
  trigger,
}: MatterIntakeTemplateRowContextMenuProps) {
  return (
    <ContextMenu
      entityName="intake template"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(template.label, "Template label");
            }}
          >
            <Clipboard />
            Copy template label
          </ContextMenuItem>
          <ContextMenuItem
            disabled={!template.description}
            onSelect={() => {
              void copyToClipboard(template.description ?? "", "Description");
            }}
          >
            <Clipboard />
            Copy description
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
